<template>
    <div id="mapContainer" v-if="!loading">
        <GMapMap ref="gmap"
                  class="property-map__map"
                  :center="marker"
                  :zoom="8"
                  style="width:100%;  height: 100%;"
                  :options="mapOptions">
        </GMapMap>
    </div>
</template>

<script>
    import { createMapIconMarker, getAdvancedMarkerMapOptions, loadAdvancedMarkerLibraryForMap, removeMarker } from '@/utils/mapMarkers.js'

    export default {
        computed: {
            mapOptions: function () {
                return getAdvancedMarkerMapOptions(this.$store.state.mapOptions)
            },

            marker: function () {
                if (!this.location) {
                    return null
                }

                return {
                    lat: this.location.latitude,
                    lng: this.location.longitude
                }
            },

            markerIcon: function () {
                return this.$store.state.mapOptions.markerIcon
            },
        },

        created: function () {
            var vm = this

            vm.$gmapApiPromiseLazy().then(() => vm.Init())
        },

        data() {
            return {
                loading: true,
                mapMarker: null,
                mapObject: null
            }
        },

        methods: {
            Init: function () {
                this.loading = false
                this.$nextTick(() => {
                    this.$refs.gmap.$mapPromise.then(map => {
                        this.mapObject = map
                        this.renderMarker()
                    })
                })
            },

            clearMarker: function () {
                if (this.mapMarker) {
                    removeMarker(this.mapMarker)
                    this.mapMarker = null
                }
            },

            renderMarker: async function () {
                if (!this.mapObject || !this.marker) {
                    return
                }

                this.clearMarker()
                await loadAdvancedMarkerLibraryForMap(this.mapOptions)

                this.mapMarker = createMapIconMarker({
                    map: this.mapObject,
                    position: this.marker,
                    icon: this.markerIcon,
                    mapObject: this.mapObject
                })
            }
        },

        props: {
            location: Object
        },

        unmounted: function () {
            this.clearMarker()
        },

        watch: {
            marker: function () {
                this.renderMarker()
            }
        }
    }
</script>

<style>
    .property-map__map {
        width: 100%;
        height: 100%;
    }
</style>
